<template>
  <div>
    <div>
      <div>
        <label class="form-label">Каким ролям показывать:</label>
      </div>
      <CheckboxGroup v-for="n in roles"
                     class="d-inline-block mr-4"
                     :fid="`tag-${n.id}`"
                     :key="`ch-${n.id}`"
                     :checkboxvalue="n.id"
                     v-model="object.roles"
                     :label="$t(n.title)"/>
      <ValidationError class="mt-1" validationId="roles"/>
    </div>
    <CountriesCheckboxSelect v-if="selectModels"
                             :object="object"
                             field="countries"
                             :countries="selectModels.countries || []"
                             label="Каким странам показывать:"/>

    <div v-if="selectModels">
      <div>
        <label class="form-label">Каким тарифам показывать:</label>
      </div>
      <div>
        <CheckboxGroup class="d-inline-block mr-4"
                       fid="allTariffs"
                       :value="allTariffs"
                       @input="allTariffsClicked"
                       label="Всем"/>
      </div>
      <CheckboxGroup v-for="t in selectModels.tariffs"
                     class="d-inline-block mr-4"
                     :fid="`tariff-${t.id}`"
                     :key="`tar-${t.id}`"
                     :checkboxvalue="t.id"
                     v-model="object.tariffs"
                     :label="$t(t.title)"/>
      <ValidationError class="mt-1" validationId="tariffs"/>
    </div>
  </div>

</template>

<script setup>
import CheckboxGroup from "@/components/form/CheckboxGroup"
import ValidationError from "@/components/form/ValidationError"
import CountriesCheckboxSelect from "@/components/parts/datatable/form/superadmin/CountriesCheckboxSelect.vue"
import { onMounted, computed} from "vue"

const props = defineProps({
  object: {},
  selectModels: {
    type: Object
  },
  options: {}
})

const roles = [
  { id: '2', title: 'superadministrator' },
  { id: '3', title: 'manager' },
  { id: '4', title: 'doctor' },
]

onMounted(() => {
  if(props.object.tariffs === null || props.object.tariffs === undefined) {
    props.object.tariffs = []
  } else {
    props.object.tariffs = props.object.tariffs.map(t => Number(t))
  }
})

const allTariffs = computed(() => {
  if(!props.object?.tariffs || !props.selectModels?.tariffs) return false
  return props.object.tariffs.length === props.selectModels.tariffs.length
})

const allTariffsClicked = () => {
  if(allTariffs.value) {
    props.object.tariffs = []
  } else {
    props.object.tariffs = props.selectModels.tariffs.map(t => t.id)
  }
}
</script>
